import type * as Jimp from 'jimp';

export const MAX_COLOR_VARIATIONS = 500;

export const getColorVariations = (
  imageData: Jimp['bitmap'],
  maxColorVariations = MAX_COLOR_VARIATIONS,
) => {
  const imageDataLength = imageData.data.length;
  const colorVariations: string[] = [];

  for (let i = 0; i <= imageDataLength; i += 4) {
    if (
      !imageData.data[i] ||
      !imageData.data[i + 1] ||
      !imageData.data[i + 2] ||
      colorVariations.length >= maxColorVariations
    )
      break;

    const colorVariation =
      String(imageData.data[i]) + String(imageData.data[i + 1]) + String(imageData.data[i + 2]);

    if (!colorVariations.includes(colorVariation)) {
      colorVariations.push(colorVariation);
    }
  }

  return colorVariations;
};
